import React from "react";
import PropTypes from "prop-types";

// Industry benchmark gauges derived client-side from the summary rates. "Spam complaints" is intentionally
// omitted — the Paubox webhook records no complaint events, so there is no data to gauge (S3DEV2-7412).
const pct = value => (value == null ? 0 : value * 100);

// direction "up": higher is better (pass when rate >= benchmark); "down": lower is better.
const GAUGES = [
  { key: "delivery", label: "Delivery Rate", field: "DeliveryRate", benchmark: 95, direction: "up" },
  { key: "open", label: "Open Rate", field: "OpenRate", benchmark: 20, direction: "up" },
  { key: "bounce", label: "Bounce Rate", field: "BounceRate", benchmark: 2, direction: "down" }
];

const Gauge = ({ label, value, benchmark, direction }) => {
  const passing =
    direction === "up" ? value >= benchmark : value <= benchmark;
  const color = passing ? "#10b981" : "#ef4444";
  const benchmarkText =
    direction === "up" ? `Target ≥ ${benchmark}%` : `Target < ${benchmark}%`;

  return (
    <div className="gauge">
      <div className="gauge-header">
        <span className="gauge-label">{label}</span>
        <span className="gauge-value" style={{ color }}>
          {value.toFixed(1)}%
        </span>
      </div>
      <div className="gauge-track">
        <div
          className="gauge-fill"
          style={{
            width: `${Math.min(100, Math.max(0, value))}%`,
            backgroundColor: color
          }}
        />
        <div
          className="gauge-benchmark"
          style={{ left: `${Math.min(100, Math.max(0, benchmark))}%` }}
        />
      </div>
      <div className="gauge-benchmark-label">
        {benchmarkText} · {passing ? "On target" : "Needs attention"}
      </div>
    </div>
  );
};

Gauge.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  benchmark: PropTypes.number.isRequired,
  direction: PropTypes.oneOf(["up", "down"]).isRequired
};

const DeliverabilityHealth = ({ summary }) => {
  const s = summary || {};
  return (
    <div className="deliverability-health">
      <h3>Deliverability Health</h3>
      <div className="gauge-grid">
        {GAUGES.map(g => (
          <Gauge
            key={g.key}
            label={g.label}
            value={pct(s[g.field])}
            benchmark={g.benchmark}
            direction={g.direction}
          />
        ))}
      </div>
    </div>
  );
};

DeliverabilityHealth.propTypes = {
  summary: PropTypes.shape({
    DeliveryRate: PropTypes.number,
    OpenRate: PropTypes.number,
    BounceRate: PropTypes.number
  })
};

export default DeliverabilityHealth;
